export const useSxStyles = () => {
  return {
    customDataLabel: {
      width: 0,
      minWidth: 'fit-content',
      whiteSpace: 'nowrap',
      fontWeight: 'bold',
    },
  };
};
